// Ponto único da soma do valor das faixas do payload de usePayrollValueBandsChart, usado pelo gráfico e pelo
// card de valor da folha
export function sumBandsTotalValue(faixas) {
  return faixas.reduce((sum, faixa) => sum + faixa.valorTotal, 0);
}
